import React from 'react';
import RegisterView from './RegisterView';

const RegisterModule = () => {
  return <RegisterView />;
};

export default RegisterModule;
